import "../css/app.css";
import Alpine from "alpinejs";
import Focus from "@alpinejs/focus";
import Modal from "./components/modal";
import HubspotForm from "./components/hubspot-form";
import { intersectEffect } from "./components/intersect-effect";
import logoLink from "./components/logo-link";
import StepsAnimate from "./components/steps-animate";
import StickyHeader from "./components/sticky-header";

window.Alpine = Alpine;

Alpine.plugin(Focus);

Alpine.store("modal", Modal);
Alpine.data("hubspotForm", HubspotForm);
Alpine.data("stepsAnimate", StepsAnimate);

const registerLazyFlickityComponents = async () => {
  const hasTestimonialCarousel = !!document.querySelector(
    '[x-data*="testimonialCarousel"]',
  );

  if (!hasTestimonialCarousel) {
    return;
  }

  try {
    await import("../css/flickity-components.css");

    if (hasTestimonialCarousel) {
      const module = await import("./components/testimonial-carousel");
      Alpine.data("testimonialCarousel", module.default);
    }
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error("[venn] flickity lazy-load failed", error);
    }
  }
};

const registerLazyCssBundles = async () => {
  const hasHubspotForm = !!document.querySelector('[x-data*="hubspotForm"]');
  const hasGradientCards = !!document.querySelector('.wp-block-venn-gradient-cards');
  const hasSteps = !!document.querySelector('.wp-block-venn-steps');

  if (!hasHubspotForm && !hasGradientCards && !hasSteps) {
    return;
  }

  try {
    const imports = [];

    if (hasHubspotForm) {
      imports.push(import("../css/hubspot.css"));
    }

    if (hasGradientCards) {
      imports.push(import("../css/gradient-cards.css"));
    }

    if (hasSteps) {
      imports.push(import("../css/steps.css"));
    }

    await Promise.all(imports);
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error("[venn] conditional css lazy-load failed", error);
    }
  }
};

const bootstrap = async () => {
  await registerLazyCssBundles();
  await registerLazyFlickityComponents();
  Alpine.start();

  (() => {
    intersectEffect(".fade", "fade-init", 0.25);
    logoLink();
    StickyHeader();
  })();
};

bootstrap();
